<template>
  <div class="create-new-client-component">
    <v-loader v-if="!currentOrder.id || checkingBasketItemsChanges" fixed />

    <s-tabs>
      <s-tab name="Быстрый просмотр" :selected="true">
        <div class="fast-order-header">
          <h1 class="font-weight-regular">
            Заказ: {{ orderNumber }}
          </h1>

          <div v-if="filialIsNotConnected" class="fast-order-header-alert">
            <span class="fast-order-header-alert_icon">
              <font-awesome-icon icon="exclamation" />
            </span>

            Филиал не подключен к FAKT

            <span class="fast-order-header-alert_icon">
              <font-awesome-icon icon="exclamation" />
            </span>
          </div>

          <client-phone-btn
            v-if="currentOrder.id"
            :order="currentOrder"
            :rounded="false"
            show-info-btn
            @info-btn-click="openOtherWindow('history')"
          />
        </div>

        <div class="button-group d-flex justify-between">
          <v-row class="justify-space-between">
            <v-col sm="5">
              <v-btn
                class="button button-back"
                width="100%"
                color="#F1F3F6"
                :disabled="checkingBasketItemsChanges"
                @click="goBack"
              >
                <font-awesome-icon icon="chevron-left" />
                Вернуться назад
              </v-btn>
            </v-col>
            <v-col sm="5">
              <v-btn
                v-if="!isSourceAggregator"
                class="button button-edit"
                width="100%"
                color="#F1F3F6"
                :loading="isLoading"
                @click="handleEdit"
              >
                <font-awesome-icon icon="edit" />
                Редактировать
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <order-help v-if="!isSourceAggregator" />

        <div v-if="currentOrder.source" class="mb-5">
          <source-card :source="currentOrder.source" />
        </div>

        <div v-if="isSourceAggregator" class="aggregators-order-info">
          <p class="label">
            Агрегатор: <b>{{ getAggregatorName }}</b>
          </p>
          <!--          <p class="label">-->
          <!--            Бренд:-->
          <!--            <b v-if="currentOrder.setdelivery">СетДоставка</b>-->
          <!--            <b v-else>Сушисет</b>-->
          <!--          </p>-->
          <p class="label">
            Номер заказа в агрегаторе: <b>{{ currentOrder.externalId }}</b>
          </p>
        </div>

        <div v-if="showAddressSection" class="street-section">
          <v-row>
            <v-col sm="10">
              <div class="street-field">
                <span class="label">Адрес доставки:</span>
                <v-text-field
                  v-model="street"
                  hide-details="auto"
                  class="text-field"
                  disabled
                  flat
                  solo
                />
              </div>
            </v-col>
            <v-col sm="2">
              <span class="label">Дом:</span>
              <v-text-field
                v-model="house"
                hide-details="auto"
                class="text-field"
                disabled
                flat
                solo
              />
            </v-col>
          </v-row>

          <v-row class="address-inputs">
            <v-col sm="3">
              <span class="label">Кв/офис:</span>
              <v-text-field
                v-model="apartmentNumber"
                hide-details="auto"
                class="text-field"
                disabled
                flat
                solo
              />
            </v-col>
            <v-col sm="3">
              <span class="label">Этаж:</span>
              <v-text-field
                v-model="floor"
                hide-details="auto"
                class="text-field"
                disabled
                flat
                solo
              />
            </v-col>
            <v-col sm="3">
              <span class="label">Подъезд:</span>
              <v-text-field
                v-model="entry"
                hide-details="auto"
                class="text-field"
                disabled
                flat
                solo
              />
            </v-col>
            <v-col sm="3">
              <span class="label">Домофон:</span>
              <v-text-field
                v-model="doorCode"
                hide-details="auto"
                class="text-field"
                disabled
                flat
                solo
              />
            </v-col>
          </v-row>

          <div class="address-info">
            <div>
              <div v-if="polygonInfoLabel" class="polygon-info">
                Филиал: {{ polygonInfoLabel }}
              </div>
              <div v-else class="polygon-error">
                <font-awesome-icon icon="exclamation-triangle" /> Адрес не
                входит в зону доставки!
                <span v-if="!hasGeo">Координаты не определены</span>
              </div>
            </div>

            <div class="geo-info">
              <router-link v-if="hasGeo" :to="mapLink" tag="a">
                <font-awesome-icon icon="map-marker-alt" />
                Посмотреть на карте
              </router-link>
            </div>
          </div>
        </div>

        <template v-if="showPickupSection">
          <div class="pickup-section">
            <span class="label">Тип доставки:</span>
            <h3>Самовывоз</h3>
            <!-- Компактный десктоп: в правой панели филиала нет, показываем
                 его здесь, как у заказа с доставкой -->
            <div v-if="pickupFilialName" class="pickup-filial">
              Филиал: {{ pickupFilialName }}
            </div>
          </div>
        </template>

        <template v-if="showAggregatorSection">
          <div class="pickup-section">
            <span class="label">Тип доставки:</span>
            <h3>Доставляет курьер агрегатора</h3>
          </div>
        </template>

        <div v-if="serviceComment" class="service-comment-section">
          <span class="label">Дополнительная информация:</span>
          <p class="service-comment-text">
            {{ serviceComment }}
          </p>
        </div>

        <div class="comment-section" @click="openCourierCommentWindow">
          <span class="label">Комментарий:</span>
          <v-textarea
            v-model="comment"
            hide-details="auto"
            class="textarea-field"
            auto-grow
            disabled
            flat
            solo
          />
        </div>
      </s-tab>
      <s-tab name="История заказа" lazy>
        <order-state-history :order-id="$route.query.id" />
      </s-tab>
    </s-tabs>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import OrderHelp from './OrderHelp'
  import _ from 'lodash'
  import PolygonType from '@/models/enums/PolygonType'
  import STabs from '@/components/ui/tabs/STabs'
  import STab from '@/components/ui/tabs/STab'
  import OrderStateHistory from '@/components/order-processing/order-components/history/order-state-history/OrderStateHistory'
  import DeliveryType from '@/models/enums/DeliveryType'
  import OrderStatus from '@/models/enums/OrderStatus'
  import ClientPhoneBtn from '@/components/order-card/ClientPhoneBtn.vue'
  import SourceCard from '@/components/order-processing/fast-order/client-address/SourceCard.vue'
  import orderEdit from '@/mixins/order-edit'

  // import VKeyboard from '@/components/keyboard/Keyboard'

  export default {
    name: 'ClientAddress',
    components: {
      SourceCard,
      ClientPhoneBtn,
      OrderStateHistory,
      STab,
      STabs,
      OrderHelp,
      VLoader,
    // VKeyboard,
    },
    mixins: [orderEdit],
    data () {
      return {
        showSnackbar: false,
        isLoading: false,
        comment: '',
        showPhoneKeyboard: true,
        timeout: null,
        tab: null,
      }
    },
    computed: {
      ...mapState({
        currentOrder: (state) => state.orders.currentEditOrder,
        basket: (state) => state.baskets.basket,
        orderId: (state) => state.fastOrder.orderId,
        clientAddress: (state) => state.fastOrder.clientAddress,
        newClientPhone: (state) => state.newOrder.newClientPhone,
        checkingBasketItemsChanges: (state) =>
          state.editSession.checkingBasketItemsChanges,
      }),
      ...mapGetters({
        street: 'fastOrder/getClientStreet',
        house: 'fastOrder/getClientHouse',
        floor: 'fastOrder/getClientFloor',
        entry: 'fastOrder/getClientEntry',
        doorCode: 'fastOrder/getClientDoorCode',
        apartmentNumber: 'fastOrder/getClientApartmentNumber',
        clientAddress: 'fastOrder/getAddress',
        isSourceAggregator: 'baskets/isSourceAggregator',
        isOrderPaid: 'orders/isOrderPaid',
        indicateFilialConnectionStatus: 'app/indicateFilialConnectionStatus',
      /* polygon: 'fastOrder/getPolygon',
        polygonInfoLabel: 'fastOrder/polygonInfoLabel',
        hasGeo: 'fastOrder/hasGeo',
        mapLink: 'fastOrder/mapLink', */
      }),
      orderNumber () {
        return this.currentOrder?.formattedCode ? `№${this.currentOrder.formattedCode}` : ''
      },
      serviceComment () {
        return this.basket?.serviceComment || ''
      },
      filialIsNotConnected () {
        return (
          this.indicateFilialConnectionStatus &&
        this.currentOrder?.filial?.isConnected === false
        )
      },
      polygon () {
        return this.basket.polygon || {}
      },
      polygonFilial () {
        return this.currentOrder.filial || {}
      },
      // точка самовывоза - филиал корзины, как в плашке правой панели
      pickupFilialName () {
        return this.basket?.filial?.name || ''
      },
      polygonInfoLabel () {
        if (!_.isEmpty(this.polygon)) {
          const type = PolygonType.getName(this.polygon.type)
          return `${this.polygonFilial.name}, ${type} зона`
        }
        return ''
      },
      hasGeo () {
        return (
          !this.clientAddress.break_address &&
          this.clientAddress.latGeo &&
          this.clientAddress.letGeo
        )
      },
      mapLink () {
        return `/geo/couriers-map?filialId=${this.polygonFilial.id}&orderId=${this.currentOrder.id}`
      },
      showAddressSection: function () {
        return this.basket && this.basket.deliveryType === DeliveryType.Delivery
      },
      showAggregatorSection: function () {
        return this.basket && this.basket.deliveryType === DeliveryType.Aggregator
      },
      showPickupSection: function () {
        return this.basket && this.basket.deliveryType === DeliveryType.Self
      },
      getAggregatorName () {
        return this.basket?.basketSourceDescription || this.basket?.basketSource
      },
      shouldPay () {
        return (
          this.currentOrder.orderStatus === OrderStatus.ReadyForIssue &&
          this.currentOrder.deliveryType === DeliveryType.Self &&
          !this.isOrderPaid
        )
      },
      editButtonLabel () {
        return this.shouldPay ? 'Оплатить и завершить' : 'Редактировать'
      },
      editButtonIcon () {
        return this.shouldPay ? 'receipt' : 'edit'
      },
    },
    watch: {
      basket () {
        this.comment = this.basket.commentForCourier || ''
      },
    },
    mounted () {
      this.comment = this.basket.commentForCourier || ''
      if (this.newClientPhone) {
        this.$nextTick(() => {
          this.phone = this.newClientPhone
        })
      }
    },
    methods: {
      openOtherWindow (window) {
        if (!window) return
        if (this.currentOtherWindow === window) {
          this.$store.commit(this.orderEditPrefix + '/setCurrentOtherWindow', undefined)
        } else {
          this.$store.commit(this.orderEditPrefix + '/setCurrentOtherWindow', window)
          this.$store.commit(this.orderEditPrefix + '/togglePromotionsWindow', false)
        }
      },
      openCourierCommentWindow () {
        this.$store.commit('fastOrder/setCurrentOtherWindow', 'courierComment')
      },
      handleEdit () {
        // if (this.shouldPay) {
        //  this.$store.commit('orders/setShowPaymentDialog', true)
        // } else {
        // Не добавляем открытие сессии, так как сессия уже открыта после входа на страницу быстрого редактирования заказа
        this.$router.push({
          path: '/edit-order',
          query: {
            id: this.orderId,
          },
        })
        // }
      },
      goBack () {
        // Возврат на предыдущую страницу (список с сохранённым поиском/фильтром);
        // при прямом открытии вкладки истории нет - уходим на список заказов.
        if (window.history.length > 1) {
          this.$router.back()
        } else {
          this.$router.push('/orders')
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.aggregators-order-info {
  margin-bottom: 15px;
  p.label {
    font-size: 14px;
  }
}

.fast-order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  h1 {
    margin: 0 30px 0 0;
  }

  &-alert {
    color: @color-pink;
    display: flex;
    align-items: center;
    font-size: 18px;
    text-transform: uppercase;

    &_icon {
      margin: 0 7px;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      //background: @color-pink;
      //color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      position: relative;
      //border: 1px solid @color-pink;
      /*&:before {
        content: '';
        position: absolute;
        border: 17px solid transparent; border-bottom: 30px solid @color-pink;
        z-index: -1;
        bottom: 0
      }*/
    }

    .media-small-pc({
      font-size: 14px;
      &_icon {
        margin: 0 5px;
      }

    });
  }
}
//noinspection ALL
.create-new-client-component {
  position: relative;
  z-index: 0;

  .comment-section {
    cursor: pointer;

    // текст комментария читается как заголовок «Доставляет курьер агрегатора» (h3),
    // а не как приглушённый текст отключённого поля
    ::v-deep .v-input--is-disabled textarea {
      font-size: 1.17em;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.87);
    }
  }

  .address-info {
    padding: 30px 0;
    display: flex;
    flex-wrap: wrap;

    .geo-info {
      margin-left: 50px;

      a {
        color: inherit !important;
      }
    }

    .polygon-error {
      color: red;

      svg {
        margin-right: 10px;
        .fill-svg(red);
      }
    }
  }

  h1 {
    font-size: 34px;
    line-height: 1;
  }

  .label {
    display: block;
    margin-bottom: 14px;
    font-size: 20px;
    line-height: 21px;
  }

  .button {
    height: 80px;
    border-radius: 10px;

    svg {
      margin-right: 8px;
    }
  }

  .text-field {
    ::v-deep {
      .v-input__slot {
        height: 80px;
      }
    }
  }

  .text-field,
  .textarea-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    &.error--text {
      ::v-deep {
        .v-input__slot {
          border: 2px solid @color-error;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .button-group {
    margin-bottom: 30px;

    .button {
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;
    }

    .button-back {
      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-edit {
      color: @color-primary;

      svg {
        .fill-svg(@color-primary);
      }
    }
  }

  .street-section {
    margin-bottom: 24px;
  }

  // Компактный десктоп: страница быстрого просмотра целиком на одном экране
  // (на 1100x759 было 981px). Кнопки 65px, как в окнах оформления; поля адреса
  // только для чтения, поэтому ниже и с меньшим шрифтом
  .media-compact-pc({
    ::v-deep .s-tabs-headers {
      margin-bottom: 12px;
    }

    .fast-order-header {
      margin-bottom: 12px;
    }

    h1 {
      font-size: 28px;
    }

    .button-group {
      margin-bottom: 4px;

      .button {
        height: 65px;
      }
    }

    // подсказка оператору на компактном десктопе не показывается - место под адрес
    ::v-deep .aside-order-help-component {
      display: none;
    }

    .label {
      margin-bottom: 6px;
      font-size: 16px;
    }

    .text-field ::v-deep .v-input__slot {
      height: 56px;
      min-height: 56px;

      input {
        font-size: 20px;
      }
    }

    .street-section {
      margin-bottom: 12px;
    }

    .address-info {
      padding: 12px 0;
    }
  });

  .pickup-section {
    margin-bottom: 24px;

    // вне компактного десктопа филиал самовывоза показывает плашка в правой панели
    .pickup-filial {
      display: none;
      padding-top: 12px;

      .media-compact-pc({
        display: block;
      });
    }
  }

  .service-comment-section {
    margin-bottom: 24px;

    .service-comment-text {
      margin: 0;
      white-space: pre-line;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .user-names {
    min-height: 208px;

    .button {
      font-size: 24px;
      line-height: 18px;
    }
  }

  .media-lg({
    .button-edit {
      display: none;
    }
  });
}
</style>
